import Storage from '../Storage.js';

Storage.setConfig("templates", {
  section: "etc",
  config: {
    method: "templates/",
    title: "Шаблоны",
    objectName: "Шаблон"
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    name: {
      default: "",
      type: "text",
      title: "Название",
      preset: false,
      width: "auto"
    }, 
    postalcode: {
      default: "",
      type: "text",
      title: "Индекс",
      preset: false,
    },
    address: {
      default: {region:"",locality:"",street:"",other:""},
      type: "address",
      //request: "inputs/address/",
      title: "Адрес",
      preset: false,
      width: false,
      placeholder: {
        region: "Регион",
        locality: "Населенный пункт",
        street: "Улица",
        other: "Дом, квартира ..."
      }
    },
    
  }
});



// WEBPACK FOOTER //
// ./src/config/templates.js